import React from "react";

const SvgOurInsights = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.5 10H3.33333M10 2.5V3.33333M16.6667 10H17.5M4.66667 4.66667L5.25 5.25M15.3333 4.66667L14.75 5.25M8.08333 14.1667H11.9167M7.5 13.3333C6.80039 12.8086 6.28361 12.0771 6.02286 11.2424C5.76211 10.4076 5.77061 9.51202 6.04715 8.68238C6.3237 7.85275 6.85427 7.13116 7.56371 6.61982C8.27315 6.10849 9.12549 5.83333 10 5.83333C10.8745 5.83333 11.7269 6.10849 12.4363 6.61982C13.1457 7.13116 13.6763 7.85275 13.9528 8.68238C14.2294 9.51202 14.2379 10.4076 13.9771 11.2424C13.7164 12.0771 13.1996 12.8086 12.5 13.3333C12.1746 13.6554 11.9297 14.0495 11.7849 14.4839C11.6401 14.9182 11.5996 15.3805 11.6667 15.8333C11.6667 16.2754 11.4911 16.6993 11.1785 17.0118C10.866 17.3244 10.442 17.5 10 17.5C9.55797 17.5 9.13405 17.3244 8.82149 17.0118C8.50893 16.6993 8.33333 16.2754 8.33333 15.8333C8.40038 15.3805 8.35988 14.9182 8.21511 14.4839C8.07034 14.0495 7.82536 13.6554 7.5 13.3333Z"
      stroke="#0C0324"
      stroke-width="1.5"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default SvgOurInsights;
